import "./TabelaRanking.css";
import iconTrofeuOuro from "../imagem/iconTrofeuOuro.svg";
import iconTrofeuPrata from "../imagem/iconTrofeuPrata.svg";
import iconTrofeuBronze from "../imagem/iconTrofeuBronze.svg";
import Table from "@mui/material/Table";
import {
  Avatar,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
} from "@mui/material";
import avatar1 from "../imagem/perfil/avatar1.svg";
import avatar2 from "../imagem/perfil/avatar2.svg";
import avatar3 from "../imagem/perfil/avatar3.svg";
import avatar4 from "../imagem/perfil/avatar4.svg";
import avatar5 from "../imagem/perfil/avatar5.svg";
import avatar6 from "../imagem/perfil/avatar6.svg";
import avatar7 from "../imagem/perfil/avatar7.svg";
import avatar8 from "../imagem/perfil/avatar8.svg";
import avatar9 from "../imagem/perfil/avatar9.svg";
import avatar10 from "../imagem/perfil/avatar10.svg";
import avatar11 from "../imagem/perfil/avatar11.svg";
import avatar12 from "../imagem/perfil/avatar12.svg";
import avatarNulo from "../imagem/perfil/avatarNulo.png";

export default function TabelaRanking({ colunas, dados, aviso }) {
  const imagens = {
    avatar1,
    avatar2,
    avatar3,
    avatar4,
    avatar5,
    avatar6,
    avatar7,
    avatar8,
    avatar9,
    avatar10,
    avatar11,
    avatar12,
  };
  return (
    <div className="container_table">
      <Table
        sx={{
          borderRadius: "10px",
          borderCollapse: "separate",
          width: "100%",
          fontFamily: '"Poppins", sans-serif',
        }}
        className="caixas_tabela"
      >
        <TableHead>
          <TableRow>
            {colunas.map((coluna, index) => (
              <TableCell
                key={index}
                sx={{
                  color: "var(--cor-roxoEscuro)",
                  fontSize: "17px",
                }}
              >
                {coluna}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {dados.length === 0 ? (
            <TableRow>
              <TableCell sx={{ textAlign: "center", width: "40%" }}>
                {aviso}
              </TableCell>
            </TableRow>
          ) : (
            dados.slice(0, 10).map((dado, i) => (
              <TableRow key={i}>
                <TableCell sx={{ width: "40%" }}>
                  <div
                    className={
                      i === 0 || i < 3
                        ? "primeiros_colocados"
                        : i > 2 && i < 7
                        ? "outros_colocados"
                        : "ultimos_colocados"
                      
                    }
                  >
                    {i + 1 + "°"}
                    {i === 0 ? (
                      <img src={iconTrofeuOuro} className="trofeu_ouro" />
                    ) : i === 1 ? (
                      <img src={iconTrofeuPrata} className="trofeu_prata" />
                    ) : i === 2 ? (
                      <img src={iconTrofeuBronze} className="trofeu_bronze" />
                    ) : (
                      ""
                    )}
                  </div>
                </TableCell>
                <TableCell
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  <Avatar
                    src={dado.avatar ? imagens[dado.avatar] : avatarNulo}
                    sx={{
                      margin: "0.5em 0.5em",
                      objectFit: "contain",
                      maxWidth: "20px",
                      maxHeight: "20px", 
                      marginRight: "8px",
                    }}
                  />
                  {dado.nome}
                </TableCell>

                <TableCell>{dado.pontuacao}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
